module.exports = __webpack_public_path__ + "static/media/Agent_tool_Guidelines.59931cda.pdf";